import React from 'react'
import "../style/Categorie_card.css";




function Trax({title}) {
  return (
    <div className='iii'>
        <div className="tit-p">
          <h4>{title}</h4>
        </div>{" "}
      {/* </div> */}
    </div>
  );
}

export default Trax